module.exports = __webpack_public_path__ + "assets/img/2.db1b0634.png";